import { BaseTooltipModel } from "./base-tooltip-model";

import { ContentColumnModel } from "./content-column-model";

import { isValid } from "@visactor/vutils";

import { mergeSpec } from "@visactor/vutils-extension";

import { getPixelPropertyStr, getScrollbarWidth, pixelPropertyStrToNumber } from "../utils";

export class ContentModel extends BaseTooltipModel {
    init() {
        this.product || (this.product = this.createElement("div", [ "container-box" ]));
        const {align: align} = this._option.getTooltipAttributes();
        "right" === align ? (this.valueBox || (this.valueBox = this._initBox("value-box", 0)), 
        this.keyBox || (this.keyBox = this._initBox("key-box", 1)), this.shapeBox || (this.shapeBox = this._initBox("shape-box", 2))) : (this.shapeBox || (this.shapeBox = this._initBox("shape-box", 0)), 
        this.keyBox || (this.keyBox = this._initBox("key-box", 1)), this.valueBox || (this.valueBox = this._initBox("value-box", 2)));
    }
    _initBox(className, index) {
        const box = new ContentColumnModel(this.product, this._option, className, index);
        return box.init(), this.children[box.childIndex] = box, box;
    }
    setStyle(style) {
        super.setStyle(mergeSpec(this._getContentContainerStyle(), style)), Object.values(this.children).forEach((c => {
            c.setStyle();
        }));
    }
    setContent() {
        Object.values(this.children).forEach((c => {
            c.setContent();
        }));
    }
    _getContentContainerStyle() {
        const defaultStyle = {
            whiteSpace: "nowrap",
            lineHeight: "0px"
        }, {panelDomHeight: panelDomHeight, panel: panelAttribute, maxContentHeight: maxContentHeight} = this._option.getTooltipAttributes();
        if (isValid(maxContentHeight) && panelDomHeight < panelAttribute.height) {
            const {shapeColumn: shapeColumn = {}, keyColumn: keyColumn = {}, valueColumn: valueColumn = {}, panel: panel = {}} = this._option.getTooltipStyle(), width = [ shapeColumn.width, shapeColumn.marginRight, keyColumn.width, keyColumn.marginRight, valueColumn.width, valueColumn.marginRight, panel.paddingRight ].reduce(((sum, cur) => sum + pixelPropertyStrToNumber(cur)), 0);
            return Object.assign(Object.assign({}, defaultStyle), {
                width: `${width + getScrollbarWidth(this._option.getContainer())}px`,
                maxHeight: getPixelPropertyStr(maxContentHeight),
                overflow: "auto"
            });
        }
        return defaultStyle;
    }
    release() {
        super.release(), this.shapeBox = null, this.keyBox = null, this.valueBox = null;
    }
}
//# sourceMappingURL=content-model.js.map
